import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Scan QR Code to pay", -1)
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "w-full",
  style: {"aspect-ratio":"53/75"}
}
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", null, "Account name: Bring bank the forest", -1)
const _hoisted_8 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Pay within ")
const _hoisted_10 = ["href", "download"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Download ")

import { Icon } from '@iconify/vue';
import useCountdown from '@/composables/useCountdown';
import { watch } from 'vue';

interface Props {
  qrCode?: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    qrCode: null
  },
  emits: ['reset'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  qrCode?: string;
}




const MINUTE_IN_SECONDS = 60;
const seconds = 5 * MINUTE_IN_SECONDS;

const { countdown, reset, start, stop } = useCountdown({
  seconds,
  immediate: false,
});

const onRestart = () => {
  reset();
  emits('reset');
};

watch(
  () => props.qrCode,
  (qrCode, previous) => {
    if (qrCode) {
      if (previous) reset();
      else start();
    } else {
      stop();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (__props.qrCode)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.qrCode,
            class: "w-60 mx-auto",
            alt: "qr-code"
          }, null, 8, _hoisted_4))
        : (_openBlock(), _createElementBlock("div", _hoisted_5))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      (__props.qrCode)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", {
              class: "text-primary text-sm inline-flex items-center hover:underline cursor-pointer",
              onClick: onRestart
            }, [
              _createTextVNode(_toDisplayString(_unref(countdown).time) + " ", 1),
              _createVNode(_unref(Icon), {
                class: "ml-1",
                icon: "akar-icons:arrow-counter-clockwise"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        href: __props.qrCode,
        download: __props.qrCode
      }, [
        _createVNode(_component_BaseButton, {
          "color-scheme": "primary",
          class: "mt-6",
          rounded: "normal",
          style: {"height":"38px"},
          disabled: !__props.qrCode
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Icon), {
              icon: "bxs:download",
              class: "mr-2"
            }),
            _hoisted_11
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 8, _hoisted_10)
    ])
  ]))
}
}

})